import { MiniGameDataObject } from "./MiniGameDataObject.js";

export function MatchGameDataObject(){
    return MiniGameDataObject("MatchGame")
}